import request, { IWorkspaceResponse } from '/@/api/http/request'

const API_PREFIX = '/wayline/api/v1'

export interface fightPathParam {
    device_sn: string
    workspace_id: string
    start_time: string
    end_time: string
    media_type: string
    sort_field: string
    order_by: string
}

export interface fightPathPageRequest {
    page: number
    page_size: number
    param: fightPathParam
}

export interface fightPath {
  id: string
  type: string
  parent_name: string
  start_time: string
  device_name: string
  folder_id: string
  job_id:string
}

/**
 * 分页接口
 * @param body
 * @returns
 */
export const getFightPathPage = async function (body: fightPathPageRequest): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/workspaces/flight-path/page`
  const result = await request.post(url, body)
  return result.data
}

// 查询飞行轨迹点数据经纬度
export const getFightPathList = async function (id: string): Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/workspaces/flight-path/points/lat-and-lon/${id}`
  const result = await request.get(url)
  return result.data
}

/** 查询飞行轨迹点数据 */
export const getFightPathsList = async (id:string):Promise<IWorkspaceResponse<any>> => {
  const url = `${API_PREFIX}/workspaces/flight-path/points/${id}`
  const result = await request.get(url)
  return result.data
}

/** 任务详情 */
export const getAlarmJobsDetails = async function (jobId:string):Promise<IWorkspaceResponse<any>> {
  const url = `${API_PREFIX}/workspaces/jobs/details/${jobId}`
  const result = await request.get(url)
  return result.data
}
